import { onChangeConditionParams } from '../components/RatesCorrectionsList/RatesCorrectionsList';
import { RateCorrectionValidationResult } from '../service/RateCorrectionsEditorHelpers/RateCorrectionsEditorHelpers';
import {
    EditorRateCorrection,
    RateControlValue,
    RateCorrectionConditionId,
    RateCorrectionMode,
    RateCorrectionType,
    RatesCorrectionsConstantsData
} from '../typings/ratesCorrections';

export const OPEN_RATE_CORRECTIONS_EDITOR = 'OPEN_RATE_CORRECTIONS_EDITOR';
export type OPEN_RATE_CORRECTIONS_EDITOR = typeof OPEN_RATE_CORRECTIONS_EDITOR;

export interface OpenRateCorrectionsEditor {
    type: OPEN_RATE_CORRECTIONS_EDITOR;
    id: string;
    correctionsData: Record<RateCorrectionType, EditorRateCorrection>;
    constants: RatesCorrectionsConstantsData;
    rateCurrentType?: RateCorrectionType;
}

export function openRateCorrectionsEditor(
    id: string,
    correctionsData: Record<RateCorrectionType, EditorRateCorrection>,
    constants: RatesCorrectionsConstantsData
): OpenRateCorrectionsEditor {
    return {
        type: OPEN_RATE_CORRECTIONS_EDITOR,
        id,
        correctionsData,
        constants
    };
}

export const CLOSE_RATE_CORRECTIONS_EDITOR = 'CLOSE_RATE_CORRECTIONS_EDITOR';
export type CLOSE_RATE_CORRECTIONS_EDITOR = typeof CLOSE_RATE_CORRECTIONS_EDITOR;

export interface CloseRateCorrectionsEditor {
    type: CLOSE_RATE_CORRECTIONS_EDITOR;
    id: string;
}

export function closeRateCorrectionsEditor(
    id: string
): CloseRateCorrectionsEditor {
    return {
        type: CLOSE_RATE_CORRECTIONS_EDITOR,
        id
    };
}

export const CLEAR_RATE_CORRECTIONS_EDITOR = 'CLEAR_RATE_CORRECTIONS_EDITOR';
export type CLEAR_RATE_CORRECTIONS_EDITOR = typeof CLEAR_RATE_CORRECTIONS_EDITOR;

export interface ClearRateCorrectionsEditor {
    type: CLEAR_RATE_CORRECTIONS_EDITOR;
    id: string;
}

export function clearRateCorrectionsEditor(
    id: string
): ClearRateCorrectionsEditor {
    return {
        type: CLEAR_RATE_CORRECTIONS_EDITOR,
        id
    };
}

export const UPDATE_RATE_CORRECTIONS_EDITOR_VALIDATION =
    'UPDATE_RATE_CORRECTIONS_EDITOR_VALIDATION';
export type UPDATE_RATE_CORRECTIONS_EDITOR_VALIDATION = typeof UPDATE_RATE_CORRECTIONS_EDITOR_VALIDATION;

export interface UpdateRateCorrectionsEditorValidation {
    type: UPDATE_RATE_CORRECTIONS_EDITOR_VALIDATION;
    id: string;
    errors: Record<RateCorrectionType, RateCorrectionValidationResult>;
}

export function updateRateCorrectionsEditorValidation(
    id: string,
    errors: Record<RateCorrectionType, RateCorrectionValidationResult>
): UpdateRateCorrectionsEditorValidation {
    return {
        type: UPDATE_RATE_CORRECTIONS_EDITOR_VALIDATION,
        id,
        errors
    };
}

export const CHANGE_CURRENT_TAB_TYPE = 'CHANGE_CURRENT_TAB_TYPE';
export type CHANGE_CURRENT_TAB_TYPE = typeof CHANGE_CURRENT_TAB_TYPE;

export interface ChangeCurrentTabType {
    type: CHANGE_CURRENT_TAB_TYPE;
    id: string;
    tabType: RateCorrectionType;
}

export function changeCurrentTabType(
    id: string,
    tabType: RateCorrectionType
): ChangeCurrentTabType {
    return {
        type: CHANGE_CURRENT_TAB_TYPE,
        id,
        tabType
    };
}

export const TOGGLE_RATE_CORRECTION_AVAILABILITY =
    'TOGGLE_RATE_CORRECTION_AVAILABILITY';
export type TOGGLE_RATE_CORRECTION_AVAILABILITY = typeof TOGGLE_RATE_CORRECTION_AVAILABILITY;

export interface ToggleRateCorrectionAvailability {
    type: TOGGLE_RATE_CORRECTION_AVAILABILITY;
    id: string;
    tabType: RateCorrectionType;
}

export function toggleRateCorrectionAvailability(
    tabType: RateCorrectionType,
    id: string
): ToggleRateCorrectionAvailability {
    return {
        type: TOGGLE_RATE_CORRECTION_AVAILABILITY,
        id,
        tabType
    };
}

export const CHANGE_RATE_CORRECTION_MASS_RATE_CONTROL =
    'CHANGE_RATE_CORRECTION_MASS_RATE_CONTROL';
export type CHANGE_RATE_CORRECTION_MASS_RATE_CONTROL = typeof CHANGE_RATE_CORRECTION_MASS_RATE_CONTROL;

export interface ChangeRateCorrectionMassRateControl {
    type: CHANGE_RATE_CORRECTION_MASS_RATE_CONTROL;
    id: string;
    tabType: RateCorrectionType;
    value: RateControlValue;
}

export function changeRateCorrectionMassRateControl(
    tabType: RateCorrectionType,
    id: string,
    value: RateControlValue
): ChangeRateCorrectionMassRateControl {
    return {
        type: CHANGE_RATE_CORRECTION_MASS_RATE_CONTROL,
        id,
        tabType,
        value
    };
}

export const CHANGE_RATE_CORRECTION_SINGLE_MASS_RATE_CONTROL =
    'CHANGE_RATE_CORRECTION_SINGLE_MASS_RATE_CONTROL';
export type CHANGE_RATE_CORRECTION_SINGLE_MASS_RATE_CONTROL = typeof CHANGE_RATE_CORRECTION_SINGLE_MASS_RATE_CONTROL;

export interface ChangeRateCorrectionSingleMassRateControl {
    type: CHANGE_RATE_CORRECTION_SINGLE_MASS_RATE_CONTROL;
    id: string;
    tabType: RateCorrectionType;
    value: RateControlValue;
}

export function changeRateCorrectionSingleMassRateControl(
    tabType: RateCorrectionType,
    id: string,
    value: RateControlValue
): ChangeRateCorrectionSingleMassRateControl {
    return {
        type: CHANGE_RATE_CORRECTION_SINGLE_MASS_RATE_CONTROL,
        id,
        tabType,
        value
    };
}

export const DELETE_RATE_CORRECTION_CONDITION =
    'DELETE_RATE_CORRECTION_CONDITION';
export type DELETE_RATE_CORRECTION_CONDITION = typeof DELETE_RATE_CORRECTION_CONDITION;

export interface DeleteRateCorrectionCondition {
    type: DELETE_RATE_CORRECTION_CONDITION;
    tabType: RateCorrectionType;
    id: string;
    conditionId: RateCorrectionConditionId;
}

export function deleteRateCorrectionCondition(
    tabType: RateCorrectionType,
    id: string,
    conditionId: RateCorrectionConditionId
): DeleteRateCorrectionCondition {
    return {
        type: DELETE_RATE_CORRECTION_CONDITION,
        tabType,
        id,
        conditionId
    };
}

export const ADD_RATE_CORRECTION_CONDITION = 'ADD_RATE_CORRECTION_CONDITION';
export type ADD_RATE_CORRECTION_CONDITION = typeof ADD_RATE_CORRECTION_CONDITION;

export interface AddRateCorrectionCondition {
    type: ADD_RATE_CORRECTION_CONDITION;
    tabType: RateCorrectionType;
    id: string;
    conditionIds: Array<RateCorrectionConditionId>;
}

export function addRateCorrectionCondition(
    tabType: RateCorrectionType,
    id: string,
    conditionIds: Array<RateCorrectionConditionId>
): AddRateCorrectionCondition {
    return {
        type: ADD_RATE_CORRECTION_CONDITION,
        tabType,
        id,
        conditionIds
    };
}

export const CHANGE_RATE_CORRECTION_CONDITION =
    'CHANGE_RATE_CORRECTION_CONDITION';
export type CHANGE_RATE_CORRECTION_CONDITION = typeof CHANGE_RATE_CORRECTION_CONDITION;

export interface ChangeRateCorrectionCondition {
    type: CHANGE_RATE_CORRECTION_CONDITION;
    id: string;
    params: onChangeConditionParams;
}

export function changeRateCorrectionCondition(
    id: string,
    params: onChangeConditionParams
): ChangeRateCorrectionCondition {
    return {
        type: CHANGE_RATE_CORRECTION_CONDITION,
        id,
        params
    };
}

export const RESET_RATE_CORRECTIONS_EDITORS = 'RESET_RATE_CORRECTIONS_EDITORS';
export type RESET_RATE_CORRECTIONS_EDITORS = typeof RESET_RATE_CORRECTIONS_EDITORS;

export interface ResetRateCorrectionsEditors {
    type: RESET_RATE_CORRECTIONS_EDITORS;
}

export function resetRateCorrectionsEditors(): ResetRateCorrectionsEditors {
    return {
        type: RESET_RATE_CORRECTIONS_EDITORS
    };
}

export const CHANGE_RATE_CORRECTION_MODE = 'CHANGE_RATE_CORRECTION_MODE';
export type CHANGE_RATE_CORRECTION_MODE = typeof CHANGE_RATE_CORRECTION_MODE;

export interface ChangeRateCorrectionMode {
    type: CHANGE_RATE_CORRECTION_MODE;
    groupId: string;
    tabType: RateCorrectionType;
    value: RateCorrectionMode;
}

export function changeRateCorrectionMode(
    groupId: string,
    tabType: RateCorrectionType,
    value: RateCorrectionMode
): ChangeRateCorrectionMode {
    return {
        type: CHANGE_RATE_CORRECTION_MODE,
        groupId,
        tabType,
        value
    };
}

export type RateCorrectionsEditorAction =
    | OpenRateCorrectionsEditor
    | ChangeCurrentTabType
    | CloseRateCorrectionsEditor
    | ClearRateCorrectionsEditor
    | DeleteRateCorrectionCondition
    | AddRateCorrectionCondition
    | ToggleRateCorrectionAvailability
    | ChangeRateCorrectionCondition
    | ChangeRateCorrectionMassRateControl
    | ResetRateCorrectionsEditors
    | UpdateRateCorrectionsEditorValidation
    | ChangeRateCorrectionMode
    | ChangeRateCorrectionSingleMassRateControl;
